export default __webpack_public_path__ + "static/media/action-plan.f9d6f35a.svg";